import { Button, Card, Row } from "antd";
import { DataRow } from "../ThirdStep/DataRow";
import { useCallback, useMemo } from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../../../configs/routesConfig";
import { transformToFloat } from "../../../../lib/transformToFloat";
import { getFormattedCurrency } from "../../../../lib/currencyFormatter";

type SuccessStepProps = {
  request: any;
};

export const SuccessStep = ({ request }: SuccessStepProps) => {
  const navigate = useNavigate();

  const accountData: string = useMemo(
    () =>
      `#${request.contractNumber}${request.propertyAddress ? " - " + request.propertyAddress : ""}`,
    [request],
  );

  const onBtnClicked = useCallback(() => {
    navigate(`${ROUTES.ACCOUNTS}/${request.contractNumber}`);
  }, [request, navigate]);

  return (
    <Card className="step">
      <Row className="justify-center flex-column align-center">
        <CheckCircleOutlined className="ok-icon success" />
        <h4 className="h h4 w-500 mt-4 mb-1">Payment Accepted</h4>
        <p className="my-0 text title">Your payment is being processed</p>
        <Row className="w-100 amount-container pa-6 justify-center flex-column align-center">
          <p className="mt-0 mb-2 text title">Amount Submitted</p>
          <h2 className="h h2 w-500">
            {getFormattedCurrency(transformToFloat(request.amount) ?? 0)}
          </h2>
        </Row>
      </Row>
      <Row className="d-block">
        {request.comments && (
          <DataRow label="Comment" value={request.comments} />
        )}
        <DataRow label="Account" value={accountData} />
        {request.selectedMethodInfo && (
          <DataRow
            label="Bank"
            value={request.selectedMethodInfo.displayName}
          />
        )}
      </Row>
      <Row className="justify-center mt-10 w-100">
        <Button
          type="primary"
          size="large"
          shape="round"
          onClick={onBtnClicked}
        >
          Return to Account
        </Button>
      </Row>
    </Card>
  );
};
